import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSidebar } from '../../contexts/SidebarContext';

const ContentWrapper = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { collapsed } = useSidebar();
  const location = useLocation();

  const publicPaths = ['/', '/login', '/register', '/forgot-password', '/pricing', '/blog', '/help', '/about', '/contact', '/careers', '/partners', '/privacy', '/terms', '/cookies'];
  const isPublicPage = publicPaths.includes(location.pathname) || location.pathname.startsWith('/blog/') || location.pathname.startsWith('/esign/sign/') || location.pathname.startsWith('/shared/') || location.pathname.startsWith('/pitch-deck/s/') || location.pathname.startsWith('/invite/');

  const showSidebar = isAuthenticated && !isPublicPage;

  return (
    <div
      className="sidebar-content-wrapper"
      style={{ marginLeft: showSidebar ? (collapsed ? 60 : 210) : 0 }}
    >
      {children}
    </div>
  );
};

export default ContentWrapper;
